import { gql } from '@apollo/client'

const FETCH_SHIPPING_GROUPS = gql`
  query ShippingGroups($storeId: String, $groupType: String) {
    shippingGroups(storeId: $storeId, groupType: $groupType) {
      id
      name
      amount
      products
      storeId
    }
  }
`

export { FETCH_SHIPPING_GROUPS }
